import React from 'react';
import ReplayIcon from '@mui/icons-material/Replay';

interface StatusResetBannerProps {
  count: number;
  onReview: () => void;
  onDismiss: () => void;
  disabled?: boolean;
}

const StatusResetBanner: React.FC<StatusResetBannerProps> = ({
  count,
  onReview,
  onDismiss,
  disabled = false,
}) => {
  if (count <= 0) return null;

  const entityWord = count === 1 ? 'entity' : 'entities';

  return (
    <div className='bdb-status-reset-banner'>
      <ReplayIcon className='bdb-status-reset-banner-icon' />
      <div className='bdb-status-reset-banner-text'>
        Last screening run reset the status of{' '}
        <strong>
          {count} {entityWord}
        </strong>{' '}
        because their underlying records changed. Their previous status is
        preserved.
      </div>
      <div className='bdb-status-reset-banner-actions'>
        <button
          type='button'
          className='bdb-status-reset-banner-link'
          onClick={onReview}
          disabled={disabled}
        >
          Review these {count}
        </button>
        <button
          type='button'
          className='bdb-status-reset-banner-dismiss'
          onClick={onDismiss}
          disabled={disabled}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default StatusResetBanner;
